import { resizeVtexImage, capitalize } from "@src/core/utils";
import type { InitialConfig, ItemsResponse } from "@src/types";
import { getItemCategory, getItemCategory2, isInStock } from "../utils";
import type {
  AnimaleBrandContext,
  AnimaleItemsPDPContext,
  AnimaleLineItemsPDPContext,
  AnimaleValuePDPContext
} from "../types";


export const AnimalePdpZone = {
  items: (context: AnimaleItemsPDPContext): ItemsResponse[] | null => {
    if (context?.items) return context.items

    if (context?.products) {
      return context.products.map((item) => {
        const listPrice = item?.offers?.offers?.[0].listPrice
        const price = item.offers?.offers?.[0].price
        const availableOffer = item?.isVariantOf?.hasVariant
          ?.flatMap(v => v?.offers?.offers ?? [])
          ?.find(o => isInStock(o?.availability))

        const sellerId = availableOffer?.seller?.identifier ?? item?.offers?.offers?.[0]?.seller?.identifier

        return {
          quantity: 1,
          index: item?.index ?? 0,
          item_brand: capitalize(item.brand.name) ?? null,
          item_name: item?.isVariantOf?.name ?? null,
          price: price ?? null,
          item_shipping_tier: null,
          discount: Number(listPrice) - Number(price),
          item_variant: item.isVariantOf?.hasVariant?.[0].name.split(" - ")[0] ?? null,
          item_variant2: (item.additionalProperty ?? []).find((p) => p.name === 'Tamanho')?.value as string ?? null,
          item_ref: item?.gtin ?? null,
          item_category: getItemCategory(item),
          item_category2: getItemCategory2(item) ?? null,
          item_id: item?.isVariantOf?.productGroupID ?? null,
          item_sku: item?.sku ?? null,
          item_url: item?.slug ?? null, // sem link/url no retorno do IS na multi-lib produtos PDC
          image_url: resizeVtexImage(item?.image?.[0].url) ?? null,
          seller_id: sellerId ?? null,
          item_list_name: item.item_list_name ?? null,
        }
      })
    }

    return null;
  },

  value: (context: AnimaleValuePDPContext): number | null => {
    if (context?.value) return context.value

    if (context?.products) {
      return context.products
        .map((item) => item.offers.lowPrice)
        .filter((price): price is number => price !== undefined)
        .reduce((sum, price) => sum + price, 0)
    }

    return null
  },

  line_items: (context: AnimaleLineItemsPDPContext): string | null => {
    if (context?.line_items) return context.line_items;

    if (context?.products) {
      return context.products
        .map((item) => item.id)
        .filter((id): id is string => Boolean(id))
        .join()
    }

    return null;
  },

  brand: (context: AnimaleBrandContext, config: InitialConfig): string | null => {
    if (config?.brand) return config.brand
    if (context?.brand) return context.brand
    if (context?.products) {
      return context.products.map((p) => p.brand.name).join().trim()
    }

    return null
  },
}